import React from 'react';
import Nav from './Nav';
import NavRedesign from './NavRedesign';
import { Outlet, ScrollRestoration } from 'react-router-dom';
import ErrorBoundary from '../../Components/Containers/ErrorBoundary/ErrorBoundary';
import DialoguesWrapper from '../../Components/Dialogues';
import HelpWrapper from '../../Components/Help';
import Mobile from '../../Components/Mobile';
import StatusBar from '../../Components/Mobile/StatusBar';
import Assistant, { Mobile as AssistantMobile } from '../../Components/Assistant';
import Analytics from '../../Components/Analytics';
import { useSession } from '../../Components/Session';
import VoIPWrapper from '../../Components/Voip';

const MobileLayout = () => {
    const { showRedesign } = useSession();

    return <div className="bg-white dark:bg-black min-h-screen">
        <ErrorBoundary fullPage={true}>
            <DialoguesWrapper>
                <HelpWrapper>
                    <Mobile>
                        <VoIPWrapper>
                            <Assistant>
                                <ScrollRestoration />
                                <StatusBar />

                                <div className="h-full w-full"> {/* pb-[7rem] */}
                                    <ErrorBoundary>
                                        <Outlet />
                                    </ErrorBoundary>
                                </div>

                                {showRedesign ? <NavRedesign /> : <Nav />}

                                <AssistantMobile />
                            </Assistant>
                        </VoIPWrapper>
                    </Mobile>
                </HelpWrapper>
            </DialoguesWrapper>
            <Analytics />
        </ErrorBoundary>
    </div>
}

export default MobileLayout;
